import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const offersQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.offers,
    queryFn: API.offers.getOffers,
  });
